import { render } from "./NigeriaTerms.vue?vue&type=template&id=9d4224c8&scoped=true"
import script from "./NigeriaTerms.vue?vue&type=script&lang=js"
export * from "./NigeriaTerms.vue?vue&type=script&lang=js"

import "./NigeriaTerms.vue?vue&type=style&index=0&id=9d4224c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d4224c8"]])

export default __exports__